var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTaskAlt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18q-1.646 0-3.104-.625-1.458-.625-2.552-1.719t-1.719-2.552Q2 11.646 2 10q0-1.667.625-3.115.625-1.447 1.719-2.541Q5.438 3.25 6.896 2.625T10 2q1.312 0 2.5.396t2.188 1.125l-1.084 1.083q-.771-.542-1.687-.823Q11 3.5 10 3.5q-2.708 0-4.604 1.896T3.5 10q0 2.708 1.896 4.604T10 16.5q2.708 0 4.604-1.896T16.5 10q0-.438-.062-.865-.063-.427-.167-.843l1.187-1.188q.271.667.407 1.396Q18 9.229 18 10q0 1.646-.625 3.104-.625 1.458-1.719 2.552t-2.541 1.719Q11.667 18 10 18Zm-1.146-4.396L5.5 10.25l1.083-1.083 2.292 2.291 8.063-8.062L18 4.458Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTaskAlt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Task_Alt.43bcb721.svg";
export { ForwardRef as ReactComponent };